
import React from 'react'

const ContactForm = () => {
  return (
    <section className=' mb-20 mt-24'>
    <h2 className='font-bold text-4xl md:text-[32px] text-[#4B4B4B] text-center'>Request a Call back!</h2>
    <p className='font-medium md:w-[90%] md:mx-auto text-base text-[#383838] mt-5 mb-9 text-center'>
    With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
    </p>
    <div className='flex md:flex-col w-[75%] md:w-[90%] mx-auto gap-10 mb-8'>
    <div className='w-full'>
        <input type="text" placeholder='Your Name' className='bg-[#fff] rounded placeholder:text-[#646266] w-full py-[15px] pl-5' style={{border: '1px solid #8B8A8E'}} />
    </div>
    <div className='w-full'>
        <input type="email" placeholder='Email' className='bg-[#fff] rounded placeholder:text-[#646266] w-full py-[15px] pl-5' style={{border: '1px solid #8B8A8E'}} />
    </div>
    </div>
    <div className='flex md:flex-col w-[75%] md:w-[90%] mx-auto gap-10 mb-8'>
    <div className='w-full'>
        <input type="number" placeholder='Phone Number' className='bg-[#fff] rounded placeholder:text-[#646266] w-full py-[15px] pl-5' style={{border: '1px solid #8B8A8E'}} />
    </div>
    <div className='w-full'>
        <input type="text" placeholder='Location' className='bg-[#fff] rounded placeholder:text-[#646266] w-full py-[15px] pl-5' style={{border: '1px solid #8B8A8E'}} />
    </div>
    </div>
    <div className='flex md:flex-col w-[75%] md:w-[90%] mx-auto gap-10 mb-8'>
    <div className='w-full'>
        <textarea className='w-full bg-[#fff] placeholder:text-[#646266] rounded pl-5 pt-[15px]' style={{border: '1px solid #8B8A8E'}} placeholder='Write Message' cols="30" rows="10"></textarea>
        
    </div>

    </div>
   <div className=' w-[75%] mx-auto flex justify-center items-center gap-10 mb-8'>
   <button className='bg-[#5146AE] rounded-lg text-white w-[200px] mx-auto py-[16px]'>Send Message</button>
   </div>
    </section>
  )
}

export default ContactForm